module.exports = __webpack_public_path__ + "img/company_slogan_white.0c4ce2c5.png";